export default __webpack_public_path__ + "static/media/1.c3ba1098.webp";